// extracted by mini-css-extract-plugin
export default {"add_case":"AddCase_add_case__Dr+hO"};